import React, { Fragment, useEffect, useState, useRef } from 'react';
import moment from 'moment';
import { Tag, Cascader, List, Card } from 'antd';
import { connect } from 'react-redux';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
// import { excelDownloadUrl } from "./ExcelAdapters/const";
import { selectImageMock } from '../../../Mock/MockJson';
import { config } from '../../constant';
import '../../CSS/style.css';

const SelectImageDetails = (props) => {
  const [optionsList, setOptionsList] = useState([]);
  const [data, setData] = useState([]);
  const [value, setValue] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);


  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear
  ]);

  const getData = async () => {
    requestCheck.current = false;
    let json = [];
    let { graphprops } = props;
    setErrorInAPI(false);
    setNoDataInDB(false);
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = selectImageMock;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      if (json) {
        // this.imageData(json)
        let optionsList = json && json.options;
        setOptionsList(json && json.options);
        setData(json && json.data);
        let value = [];
        if (
          optionsList &&
          optionsList[0] &&
          optionsList[0].value &&
          optionsList[0].children &&
          optionsList[0].children[0] &&
          optionsList[0].children[0].value
        ) {
          value = [optionsList[0].value, optionsList[0].children[0].value];
          onChange(value);
          setValue(value);
          setRefreshDateTime(moment());
        }
      }
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  // componentWillUnmount() {
  //   clearInterval(this.timeTicket);
  // }
  const filter = (inputValue, path) => {
    return path.some((option) => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
  };
  const onChange = (value) => {
    data &&
      Array.isArray(data) &&
      data.length > 0 &&
      data.map((selectData) => {
        if (
          selectData &&
          selectData.parentKey &&
          selectData.parentKey === value[0] &&
          selectData.childKey === value[1]
        ) {
          setSelectedData(selectData);
          setValue(value);
        }
        return {};
      });
  };

  const colors = [
    'steelblue',
    '#a0d911',
    '#13c2c2',
    '#faad14',
    '#c41d7f',
    '#006d75',
    '#eb2f96',
    'steelblue',
    '#a0d911',
    '#13c2c2',
    '#faad14',
    '#c41d7f',
    '#006d75',
    // "#f5222d",
    // "#faad14",

    '#eb2f96',
    'steelblue',
    '#a0d911',
    '#13c2c2',
    '#faad14',
    '#c41d7f',
    '#006d75',
    '#eb2f96',
    'steelblue',
    '#a0d911',
    '#13c2c2',
    '#faad14',
    '#c41d7f',
    '#006d75',
    '#eb2f96'
  ];

  return (
    <Fragment>
      {graphprops && graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <Fragment>
          <Cascader
            // defaultValue={optionsList && optionsList[0] && optionsList[0].value && optionsList[0].children &&
            //   optionsList[0].children[0] &&optionsList[0].children[0].value ? [optionsList[0].value,optionsList[0].children[0].value] :[]}
            value={value}
            options={optionsList}
            onChange={onChange}
            placeholder="Please select"
            showSearch={filter}
          />
          <div>
            {' '}
            <div style={{ width: '40%', float: 'left' }}>
              {selectedData &&
                selectedData.imagesList &&
                Array.isArray(selectedData.imagesList) &&
                selectedData.imagesList.length > 0 &&
                selectedData.imagesList.map((src, index) => (
                  <img
                    src={src}
                    width="300"
                    height="300"
                    key={index}
                    style={{ margin: '2px' }}
                    alt=""
                  />
                ))}
            </div>
            {/* { selectedData && selectedData.truckDetails && Array.isArray(selectedData.truckDetails) && selectedData.truckDetails.map((item)=>( */}
            <div style={{ width: '60%', float: 'left' }}>
              <List
                grid={{
                  gutter: 10,
                  column: 4
                }}
                dataSource={selectedData.truckDetails}
                style={{
                  textAlign: 'center',
                  textColor: '#fff !important'
                }}
                renderItem={(item, index) => (
                  <List.Item>
                    <Card
                      className="selectImage"
                      title={item.title}
                      style={{
                        backgroundColor: colors[index],

                        fontWeight: 'bold'
                      }}
                    >
                      {' '}
                      {item.value}
                    </Card>
                    {/* <Card title={item.title} style={{ backgroundColor: colors[index]}}>  <Card.Grid style={gridStyle}>{item.value}</Card.Grid></Card> */}
                  </List.Item>
                )}
              />
            </div>
          </div>
        </Fragment>
      )}

      {/* {
          reportName && excelDownload === "true" ? (
            <a
              href={`${excelDownloadUrl}/${reportName}`}
              style={{ fontWeight: "bold" }}
            >
              <Icon
                type="download"
                style={{
                  fontWeight: "bold",
                  marginRight: "25px",
                  marginTop: "6px",
                }}
              />
            </a>
          ) : null
        } */}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};

export default connect(mapStateToProps)(SelectImageDetails);
